import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";

function History(props) {
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), React.createElement("path", {
    d: "M10 .125C4.546.125.125 4.546.125 10S4.546 19.875 10 19.875s9.875-4.421 9.875-9.875S15.454.125 10 .125zM1.625 10a8.375 8.375 0 1116.75 0 8.375 8.375 0 01-16.75 0zm4.32-.66a.75.75 0 100 1.5h4.376a.75.75 0 00.75-.75V3.916a.75.75 0 00-1.5 0v5.422H5.944z"
  }));
}

export { History };
//# sourceMappingURL=History.js.map